import contentApi from '@/services/content-api';

const state = {
  documents: null,
  responseStatus: null,
};

const mutations = {
  setDocuments(storeState, documents) {
    // eslint-disable-next-line no-param-reassign
    storeState.documents = documents || null;
  },
  setResponseStatus(storeState, status) {
    // eslint-disable-next-line no-param-reassign
    storeState.responseStatus = status;
  },
};

const getters = {
  documents: (storeState) => storeState.documents,
  responseStatus: (storeState) => storeState.responseStatus,
  // Геттеры для конкретных документов
  personalDataPolicy: (storeState) => {
    if (!storeState.documents) return null;
    return storeState.documents.sopd || null;
  },
  distributionPolicy: (storeState) => {
    if (!storeState.documents) return null;
    return storeState.documents.sopdDistribution || null;
  },
  offerDocument: (storeState) => {
    if (!storeState.documents) return null;
    return storeState.documents.sopdOffer || null;
  },
};

const actions = {
  getMarketingProgramDocuments({ commit }) {
    return contentApi.getMarketingProgramDocuments()
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setDocuments', response.data);
        } else {
          commit('setDocuments', null);
        }
        return response;
      })
      .catch((error) => {
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
        commit('setDocuments', null);
        throw error;
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
